/**
 * Number of scheduled transports for the Scene 0 panel heading.
 *
 * Calls /api/transport-requests?scope=scheduled, but the backend has no
 * route registered under that path (transport-requests only shows up in
 * backend comments, not in a route handler). The call fails every time,
 * the catch below sets count to 0, and the panel heading always reads
 * zero scheduled transports.
 */

import { useEffect, useState } from "react";
import { api } from "../../../utils/helpers";

export function useScheduleCount() {
  const [count, setCount] = useState(null);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    api("/api/transport-requests?scope=scheduled")
      .then((r) => {
        if (!mounted) return;
        const list = Array.isArray(r?.items) ? r.items : Array.isArray(r) ? r : [];
        setItems(list);
        setCount(list.length);
      })
      .catch((e) => {
        if (!mounted) return;
        setCount(0);
        setItems([]);
        setError(e?.message || "");
      });
    return () => { mounted = false; };
  }, []);

  return { count, items, error };
}
